"use client"

import { GenericError } from "@/app/(permission based)/error"

export default function Error({
    error,
}: {
    error: Error & { digest?: string }
}) {

    return <>
        <span></span>
        <GenericError
            logToConsole={false}
            error={error}
            title={"אופסי דופסי"}
            description={<>
                הדף שניסית לטעון נתקל בשגיאה מהצד שלנו!
                <br />
                אנחנו נורא מצטערים אבל בזמן הקרוב לא נוכל להציג לכם את הדף שביקשתם..
            </>}
        />
    </>
}